<!--登录注册 -->
<template>
  <div class="centerBox">
    <div class="left">
      <div :style="logoStyle"></div>
      <div class="supgate">{{logo.protal}}</div>
    </div>
    <div class="topa">
      <a
        class="register"
        href="javascrip:void(0)"
        v-on:click="show1 = !show1"
        @click="noneshow()"
      >{{syzcName}}</a>
      <span class="column">|</span>
      <a
        class="forget"
        href="javascrip:void(0)"
        v-on:click="show2 = !show2"
        @click="noneshow()"
      >{{sywjName}}</a>
      <button class="login" id="login" :style="login" @click="addLogin()">登录</button>
    </div>
    <div class="zhezhao" id="zhezhao"></div>
    <!-- 注册弹框 -->
    <div v-if="show1" id="layer" class="layer">
      <transition name="nameoftransition1">
        <iframe :src="zcUrl" frameborder="no" scrolling="no" class="syzcshow"></iframe>
      </transition>
      <a
        href="javascrip:void(0)"
        v-on:click="show1 = !show1"
        class="syzcshowdiv1"
        id="syzcshowdiv1"
        @click="closeIframe()"
      >
        <img src="img/close.png" />
      </a>
    </div>

    <!-- 临时登录弹框 -->
    <div v-if="show2" id="layer" class="layer">
      <transition name="nameoftransition2">
        <iframe :src="wjUrl" frameborder="no" scrolling="no" class="sywjshow"></iframe>
      </transition>
      <a
        href="javascrip:void(0)"
        v-on:click="show2 = !show2"
        id="syzcshowdiv2"
        class="syzcshowdiv2"
        @click="closeIframe()"
      >
        <img src="img/close.png" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let categoryShow = JSON.parse(this.$supMainPageConfig);
    this.theme = JSON.parse(this.$supMainPageConfig).catItemImg.info7.theme;
    return {
      logo: JSON.parse(this.$supMainPageConfig).logo,
      url: JSON.parse(this.$supMainPageConfig).contactInfoShow.url,
      logurl: JSON.parse(this.$supMainPageConfig).contactInfoShow.logurl,
      styles: this.theme,
      syzcName: categoryShow.topMenuItem[0].name,
      sywjName: categoryShow.topMenuItem[1].name,
      syzcUrl: categoryShow.topMenuItem[0].url,
      sywjUrl: categoryShow.topMenuItem[1].url,
      urls: categoryShow.topMenuItem[2].url,
      show1: false,
      show2: false,
      zcUrl: "",
      wjUrl: ""
    };
  },
  created() {
    //监听iframe
    window.addEventListener("message", eve => {
      if (
        eve.data.length == 98 ||
        eve.data.length == 97 ||
        eve.data.length == 99
      ) {
        document.getElementById("zhezhao").style.display = "none";
        document.body.style.overflowY = "scroll";
        this.show1 = false;
        this.show2 = false;
      } else {
        // 去掉云之家图标
        if (
          eve.data.length > 1 &&
          eve.data.length != 97 &&
          eve.data.length != 98
        ) {
          this.init();
        }
      }
    });
  },
  mounted() {
    //监听iframe
    window.addEventListener("message", eve => {
      if (eve.source == undefined) {
        document.getElementById("zhezhao").style.display = "none";
        document.body.style.overflowY = "scroll";
        this.show1 = false;
        this.show2 = false;
      } else {
        this.init(eve);
      }
    });
    //把登录 注册地址 放入浏览器缓存
    if (this.syzcUrl != null) {
      sessionStorage.setItem("zcUrl", this.syzcUrl);
      this.zcUrl = sessionStorage.getItem("zcUrl");
    }
    if (this.sywjUrl != null) {
      sessionStorage.setItem("wjUrl", this.sywjUrl);
      this.wjUrl = sessionStorage.getItem("wjUrl");
    }
  },
  methods: {
    init(e) {
      // 去掉云之家图标
      let trayMenu = document
        .getElementById("layer")
        .children[0].contentWindow.document.getElementById(
          "_TrayMenu_"
        );
      if (trayMenu){
        trayMenu.style.display = "none";
      }
      if (e != null){
        if (e.data.indexOf("adm_login") > -1){
          let iframeDoc = document.getElementById("layer").children[0].contentWindow.document;
          let contentDiv = iframeDoc.getElementById("__kd_content__");
          let cl = iframeDoc.getElementById("kd_close")
          if (cl == null){
            // 新增元素
            //创建 i元素
            let kdClose = iframeDoc.createElement("i");
            kdClose.setAttribute("id","kd_close");
            kdClose.setAttribute("class","kdfont-guanbiyulan kd-hover-color kdfont _3zg-RY22");
            kdClose.style.top = "-350px";
            kdClose.style.position = "relative";
            kdClose.style.marginLeft = "450px";
            kdClose.onclick = function(e){
              document.getElementById("syzcshowdiv2").click();
            };
            contentDiv.appendChild(kdClose);
          }
        }
        else if (e.data.indexOf("adm_register") > -1){
          let iframeDoc = document.getElementById("layer").children[0].contentWindow.document;
          let contentDiv = iframeDoc.getElementById("__kd_content__");
          let cl = iframeDoc.getElementById("kd_close")
          if (cl == null){
            // 新增元素
            //创建 i元素
            let kdClose = iframeDoc.createElement("i");
            kdClose.setAttribute("id","kd_close");
            kdClose.setAttribute("class","kdfont-guanbiyulan kd-hover-color kdfont _3zg-RY22");
            kdClose.style.top = "-482px";
            kdClose.style.position = "relative";
            kdClose.style.marginLeft = "443px";
            kdClose.onclick = function(e){
              document.getElementById("syzcshowdiv1").click();
            };
            contentDiv.appendChild(kdClose);
          }
        }
      }
    },
    addLogin() {
      window.open(this.urls, "_blank");
    },
    closeIframe() {
      document.getElementById("zhezhao").style.display = "none";
      document.body.style.overflowY = "scroll";
    },
    noneshow() {
      document.getElementById("zhezhao").style.display = "block";
      document.body.style.overflowY = "hidden";
    }
  },
  computed: {
    logoStyle: function() {
      let logoConfig = JSON.parse(this.$supMainPageConfig).logo.imgUrl;
      return {
        backgroundImage: "url(" + logoConfig + ")",
        backgroundRepeat: "round",
        height: "41px",
        width: "124px"
      };
    },
    login: function() {
      if (this.styles == 1) {
        return {
          width: "90px",
          height: "38px",
          background:
            "linear-gradient(90deg,rgba(129, 201, 255, 1) 0%,rgba(74, 152, 255, 1) 100%)",
          borderRadius: "4px",
          border: "none",
          color: "#ffffff",
          marginLeft: "20px",
          cursor: "pointer"
        };
      }
      if (this.styles == 2) {
        return {
          width: "90px",
          height: "38px",
          background: "linear-gradient( 90deg, #6869FB 0%,#6869FB 100%)",
          borderRadius: "4px",
          border: "none",
          color: "#ffffff",
          marginLeft: "20px",
          cursor: "pointer"
        };
      }
      if (this.styles == 3) {
        return {
          width: "90px",
          height: "38px",
          background: "linear-gradient( 90deg, #29C392 0%,#29C392 100%)",
          borderRadius: "4px",
          border: "none",
          color: "#ffffff",
          marginLeft: "20px",
          cursor: "pointer"
        };
      }
      if (this.styles == 4) {
        return {
          width: "90px",
          height: "38px",
          background: "linear-gradient( 90deg, #FC8555 0%,#FC8555 100%)",
          borderRadius: "4px",
          border: "none",
          color: "#ffffff",
          marginLeft: "20px",
          cursor: "pointer"
        };
      }
    }
  }
};
</script>

<style scoped lang="scss">
.left {
  display: flex;
  margin-top: 10px;
  align-items: center;
  float: left;
}
.topa {
  display: flex;
  margin-top: 13px;
  align-items: center;
  float: right;
}
.centerBox {
  width: 100%;
  align-items: center;
}
.leftitem {
  display: flex;
  top: 4%;
  bottom: 0;
  position: absolute;
  align-items: center;
}
.leftitem .supgate {
  padding-left: 10px;
  font-size: 14px;
  color: #ffffff;
  white-space: nowrap;
  line-height: 41px;
}

.supgate {
  padding-left: 10px;
  font-size: 14px;
  color: #ffffff;
  white-space: nowrap;
  line-height: 41px;
}

.rightitem {
  display: flex;
  justify-content: flex-end;
  margin-right: 390px;
}

//过渡动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.syzcshow {
  z-index: 10;
  position: fixed;
  width: 480px;
  height: 500px;
  left: 45%;
  top: 28.5%;
  margin-left: -150px;
  margin-top: -140px;
  background-color: #ffffff;
}

.sywjshow {
  z-index: 10;
  position: fixed;
  width: 480px;
  height: 360px;
  left: 45%;
  top: 28.5%;
  margin-left: -150px;
  margin-top: -140px;
  background-color: #ffffff;
}

.syzcshowdiv1 {
  z-index: 1;
  position: fixed;
  left: 45%;
  top: 28.5%;
  margin-left: 295px;
  margin-top: -120px;
}

.syzcshowdiv2 {
  z-index: 1;
  position: fixed;
  left: 45%;
  top: 28.5%;
  margin-left: 295px;
  margin-top: -120px;
}

.zhezhao {
  width: 100%;
  height: 100%;
  background-color: #000;
  filter: alpha(opacity=50);
  -moz-opacity: 0.5;
  opacity: 0.5;
  position: fixed;
  left: 0px;
  top: 0px;
  display: none;
  z-index: 5;
}

.column {
  margin-left: 20px;
  color: #ffffff;
}

.register {
  color: #ffffff;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 20px;
  text-decoration: none;
}

.forget {
  color: #ffffff;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 20px;
  margin-left: 20px;
  text-decoration: none;
}
</style>
